const state = {
     siteConfig:'',
     caiList:JSON.parse(sessionStorage.getItem('SYS_CAILIST')||'[]') || [],
     caiJson:{},
     sysConfig:JSON.parse(sessionStorage.getItem('SYS_CONFIG')||'{}') || {},
}

const mutations = {
     setSiteConfig(state, data) {
        state.siteConfig = data;
     },
     setCaiList(state, data) {
        data.sort((a, b) => b.status - a.status);
        let caijson = {};
        for (var i=0;i<data.length;i++) {
            caijson[data[i].id] = data[i];
        }
        state.caiList = data;
        state.caiJson = caijson;
		    sessionStorage.setItem('SYS_CAILIST',JSON.stringify(data));
     },
     updateCaiList(state, updata) {
        let data = [...state.caiList];
        let caijson = {};
        for (var i=0;i<data.length;i++) {
            let newData = data[i];
            if(data[i].id==updata.id){
               newData = Object.assign({}, newData, updata);
            }
            caijson[data[i].id] = newData;
            data[i] = newData;
        }
        data.sort((a, b) => b.status - a.status);
        state.caiList = data;
        state.caiJson = caijson;
		    sessionStorage.setItem('SYS_CAILIST',JSON.stringify(data));
     },
     setSysConfig(state, data) {
        state.sysConfig = data;
		    sessionStorage.setItem('SYS_CONFIG',JSON.stringify(data));
     }
}

const actions = {

}

export default {
    state,
    mutations,
    actions
}



// WEBPACK FOOTER //
// ./src/store/modules/setting.js